<script>
const appid='wxda9fc843afddd541';
const secret='b801a87e4a80a9764c9d41ea7960c891';
export default
{
appid,//appid
secret,//appsecret
}
</script>


// WEBPACK FOOTER //
// src/components/global.vue